import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  constructor() { }
  deleteItem() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won’t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        // Do deletion logic here
        Swal.fire(
          'Deleted!',
          'Your item has been deleted.',
          'success'
        );
      }
    });
  }
  confirmAlert(
    title: string = '',
    text: string = '',
    confirmButtonText: string = '',
    cancelButtonText: string = ''
  ): Promise<boolean> {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true,
      confirmButtonColor: '#25af19',
      allowOutsideClick: false,  
      allowEscapeKey: false 
    }).then((result) => {
      return result.isConfirmed;
    });
  }

    confirmNoIconAlert(
    title: string = '',
    text: string = '',
    confirmButtonText: string = '',
    cancelButtonText: string = ''
  ): Promise<boolean> {
    return Swal.fire({
      title,
      text,
       // icon: null,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true,
      confirmButtonColor: '#248fe7',
          cancelButtonColor : '#e61b17',
      allowOutsideClick: false,  
      allowEscapeKey: false ,
       didOpen: () => {
      const titleElement = Swal.getTitle();

      if (titleElement) {
        titleElement.style.fontSize = '20px';
        titleElement.style.fontWeight = '600';
      }
    }
      
    }).then((result) => {
      return result.isConfirmed;
    });
  }

  successAlert(title: string, text: string): void {
    Swal.fire({
      title,
      text,
      icon: 'success'
    });
  }

  errorAlert(title: string, text: string): void {
    Swal.fire({
      title,
      text,
      icon: 'error'
    });
  }
}
